export default function (v, pack, km, duration) {

  let onPromotion = false
  if (v.min_price_package) {
    onPromotion =
      Number(v.min_price_package.km_option.old_monthly_total) > 0 ||
      Number(v.min_price_package.km_option.old_monthly_total_fixed) > 0
  } else {
    onPromotion = v.lease_packages.some(pkg =>
      pkg.km_options?.some(opt =>
        Number(opt.old_monthly_total) > 0 ||
        Number(opt.old_monthly_total_fixed) > 0
      )
    )
  }

  let badge = null
  if (onPromotion) {
    badge = 0
  }
  else if (v.is_new) {
    badge = 1
  }
  else if (v.is_popular) {
    badge = 2
  }
  else if (v.is_new_car) {
    badge = 3
  }
  else if (v.fuel_type == 3) {
    badge = 4
  }
  else if (v.carify_exclusive) {
    badge = 6
  }

  return {
    id: v.id,
    name: v.name,
    slug: v.slug,
    brand: v.make_name,
    fuel: v.fuel_type_display,
    year: new Date(v.registration_date).getFullYear(),
    thumb: v.profile_picture,
    images: v.images,
    price: v.min_price_package ? minimumPrice(v.min_price_package) : lowestPrice(v.lease_packages, pack, km, duration),
    badge: badge,
    favourite: v.is_user_favourite,
    down_payment_adjustment_id: v.down_payment?.adj_id ?? null
  }
}

const minimumPrice = (pkg) => {
  const price = (pkg.km_option.has_fixed_package || pkg.km_option.has_try_and_buy) ? pkg.km_option.monthly_total_fixed : pkg.km_option.monthly_total

  const promo = Number(pkg.km_option.old_monthly_total);
  const promo_fixed = Number(pkg.km_option.old_monthly_total_fixed);
  const strike = promo || promo_fixed || null;

  return { current: price, km_option: pkg.km_option, promo: strike, end_price: pkg.km_option?.try_and_buy?.end_price || 0 }
}

const lowestPrice = (lp, pack, km, duration) => {
  const kmVal = [...km.active][0]
  const durVal = [...duration.active][0]

  let previous = null;
  let cheapest = Infinity;
  let cheapest_km_option = null;
  let promotion = false;
  let filtered_lps = lp;

  // let try_and_by_only = this.blok.filter_package && this.blok.filter_package.length == 1 && this.blok.filter_package[0] == "try_and_buy";
  let try_and_by_only = pack.active.size && pack.active.has('try_and_buy')
  // limit to max 6 month; if try and buy catalog.
  if (try_and_by_only) {
    filtered_lps = filtered_lps.filter(x => x.duration_months <= 6)
  }


  if (duration.active.size > 0) { // If we have a min duration, we will have km as well
    const mon = filtered_lps.find((p) => p.duration_months == durVal);
    if (mon) {
      let km_option = mon.km_options.filter((o) => o.km == kmVal);
      if (km_option) {
        promotion = km_option.promotion_applied
        km_option.forEach(o => {
          let use = (o.has_fixed_package || o.has_try_and_buy) ? "monthly_total_fixed" : "monthly_total"
          if (pack.active.size == 1 && pack.active.has("flex")) {
            use = "monthly_total"
          }
          if (o.promotion_applied) {
            previous = o[`old_monthly_total`]; // previous = o[`old_${use}`];
          }
          if (Number(o[use]) < cheapest) {
            cheapest = Number(o[use])
            cheapest_km_option = o
          }
        })
        return { current: Number(cheapest), km_option: cheapest_km_option, strike: previous, promotion: promotion, end_price: cheapest_km_option?.try_and_buy?.end_price || 0 };
      }
    }
  } else {
    filtered_lps.forEach(p => {
      p.km_options.forEach(o => {
        let use = (o.has_fixed_package || o.has_try_and_buy) ? "monthly_total_fixed" : "monthly_total"
        if (pack.active.has("flex")) {
          use = "monthly_total"
        }
        if (Number(o[use]) < cheapest) {
          cheapest = Number(o[use])
          cheapest_km_option = o
        }
      })
    })

    return { current: Number(cheapest), km_option: cheapest_km_option, strike: previous, promotion: promotion, end_price: cheapest_km_option?.try_and_buy?.end_price || 0 };
  }
}
